const getTokenLogoURL = (address: string) =>
  `http://rise.wealwin.com/images/${address}.png`

export default getTokenLogoURL
